<template>
  <div class="p-8">
    <div class="mb-8">
      <h3 class="text-lg leading-loose">
        <input checked type="checkbox" v-model="form.buyXgetYFree.enable" /> Buy X Qty & get Y Qty Free
      </h3>
      <p class="text-sm text-gray-400 leading-normal" v-if="form.buyXgetYFree.enable">Define buy and get free items</p>
      <div class="bg-white rounded shadow border-t border-gray-200" v-if="form.buyXgetYFree.enable">
        <div class="space-y-4 divide-y divide-gray-200">
          <div class="p-2 mt-4">
            <input checked type="checkbox" v-model="form.buyXgetYFree.qty_mix" /> Enable mix count
            <div class="text-sm text-gray-400">Items count will be taken grouped within the same action and UOM.</div>
          </div>
          <table class="min-w-full ">
            <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty greater than</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Free Item Code</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Free Qty</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
            <tr class="bg-gray-300" >
              <td class="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                <input type="number" class="h-full py-2 px-2 rounded" v-model.number="buyGetFreeRule.action.qty_gt" />
              </td>
              <td class="px-6 whitespace-nowrap text-sm font-medium text-gray-900 w-1/2">
                <v-select id="shop"
                          v-model="buyGetFreeRule.action.free_item"
                          :options="buyGetFreeRule.selectableItems"
                          :filterable="false"
                          @option:selected="reloadItemUnits"
                          label="item_code"
                          :reduce="option => { return {item_code: option.item_code, desc: option.description }}"
                          class="tailwind-v-select w-full"
                          @search="searchItemCodes">
                  <template slot="option" slot-scope="option">
                    <div class="flex flex-col">
                      <p class="text-base text-gray-800">{{ option.description }}</p>
                      <div class="text-xs text-gray-500">{{ option.item_code }}</div>
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                          <span class="flex items-baseline gap-2">
                            <p class="text-base text-gray-800">{{ option.description }}</p>
                            <div class="text-xs text-gray-500">{{ option.item_code }}</div>
                          </span>
                  </template>
                  <template slot="no-options">
                    type to search item codes...
                  </template>
                </v-select>
              </td>
              <td class="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                <input type="number" class="h-full py-2 px-2 rounded" v-model.number="buyGetFreeRule.action.free_item_qty" />
                <select class="py-2 px-2 rounded" v-model="buyGetFreeRule.action.free_item_unit" >
                  <option v-for="unit in buyGetFreeRule.itemCodeUnits" :value="unit.key">{{ unit.label }}</option>
                </select>
              </td>
              <td class="text-right px-4">
                <button class="rounded bg-primary-500 text-white p-2 disabled:opacity-50" @click.prevent="addBuyGetFreeRuleAction" :disabled="canAddBuyGetRule === false"><span class="text-lg">+</span> Add</button>
              </td>
            </tr>
            <tr v-for="rule in form.buyXgetYFree.rules">
              <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ rule.qty_gt }}</td>
              <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ rule.free_item.desc }}
                <div class="text-sm text-gray-400">{{ rule.free_item.item_code }}</div>
              </td>
              <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ rule.free_item_qty }} {{ rule.free_item_unit }}</td>
              <td class="text-right px-4 flex justify-end items-center py-2">
                <button class="block rounded bg-red-500 text-white p-2 hover:red-900" @click.prevent="removeBuyXGetRule(rule)"><Icon name="trash" class="h-4 w-4 fill-current"/></button>
              </td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>

    <div class="mb-8">
      <h3 class="text-lg leading-loose">
        <input checked type="checkbox" v-model="form.itemDiscounts.enable" /> Item Discounts
      </h3>
      <p class="text-sm text-gray-400 leading-normal" v-if="form.itemDiscounts.enable">Set discounts to be applied</p>

      <div class="bg-white rounded shadow overflow-hidden" v-if="form.itemDiscounts.enable">
        <div class="p-3 mb-2">
          <div class="mb-5">
            <h2 class="text-gray-600 font-bold pb-1">Discount Type</h2>
            <select class="py-2 px-2 rounded border-gray-300 border" v-model="form.itemDiscounts.discount_type">
              <option value="percent">Percent %</option>
              <option value="fixed">Fixed</option>
            </select>
          </div>
          <div class="mb-2">
            <input checked type="checkbox" v-model="form.itemDiscounts.qty_mix" /> Enable mix count
            <div class="text-sm text-gray-400">Items count will be taken grouped within the same UOM only (without grouping by action).</div>
          </div>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty greater than</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Discount</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
            <tr class="bg-gray-300">
              <td class="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                <input type="number" class="h-full py-2 px-2 rounded" v-model.number="discountRule.qty_gt" />
              </td>
              <td class="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                <input type="number" class="h-full py-2 px-2 rounded"  v-model.number="discountRule.discount_value"/>
              </td>
              <td class="text-right px-4">
                <button class="rounded bg-primary-500 text-white p-2 disabled:opacity-50" @click.prevent="addDiscountRuleAction" :disabled="canAddDiscountRule === false"><span class="text-lg">+</span> Add</button>
              </td>
            </tr>
            <tr v-for="rule in form.itemDiscounts.rules">
              <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ rule.qty_gt }}</td>
              <td class="px-8 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                <span v-if="form.itemDiscounts.discount_type === 'percent'">{{ rule.discount_value }} %</span>
                <span v-if="form.itemDiscounts.discount_type === 'fixed'">MVR {{ rule.discount_value }}</span>
              </td>
              <td class="text-right px-4 flex justify-end items-center py-2">
                <button class="block rounded bg-red-500 text-white p-2 hover:red-900" @click.prevent="removeDiscountRule(rule)"><Icon name="trash" class="h-4 w-4 fill-current"/></button>
              </td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import __ from 'lodash'
import Icon from '@/Shared/Icon'
import vSelect from 'vue-select'

export default {
  name: 'OfferAction',
  components: {
    Icon, vSelect
  },
  props: {
    value: Object
  },
  data() {
    return {
      buyGetFreeRule: {
        itemCodeUnits: [],
        selectableItems: [],
        action: {
          qty_gt: null,
          free_item: null,
          free_item_qty: null,
          free_item_unit: null
        }
      },
      discountRule: {
        qty_gt: null,
        discount_value: null
      },
      form: {
        buyXgetYFree : {
          qty_mix : __.get(this.value, 'buyXgetYFree.qty_mix', false),
          enable : __.get(this.value, 'buyXgetYFree.enable', false),
          rules : __.get(this.value, 'buyXgetYFree.rules', [])
        },
        itemDiscounts : {
          enable: __.get(this.value, 'itemDiscounts.enable', false),
          discount_type: __.get(this.value, 'itemDiscounts.discount_type', null),
          qty_mix : __.get(this.value, 'itemDiscounts.qty_mix', false),
          rules : __.get(this.value, 'itemDiscounts.rules', [])
        }
      }
    }
  },

  watch: {
    form: {
      handler: function() {
        this.handleOnChange()
      },
      deep: true
    }
  },

  computed: {
    canAddDiscountRule() {
      let action = this.discountRule;
      if(action.qty_gt && action.discount_value && this.form.itemDiscounts.discount_type) {
        return true;
      }
      return false;
    },
    canAddBuyGetRule() {
      let action = this.buyGetFreeRule.action;
      if(action.qty_gt && action.free_item && action.free_item_qty && action.free_item_unit) {
        return true;
      }
      return false;
    }
  },

  methods: {
    handleOnChange() {
      this.$emit('input', this.form)
    },

    resetBuyGetRuleForm() {
      this.buyGetFreeRule.action = {
        qty_gt: null,
        free_item: null,
        free_item_qty: null,
        free_item_unit: null
      };
      this.buyGetFreeRule.itemCodeUnits = [];
      this.buyGetFreeRule.selectableItems = [];
    },

    resetDiscountRuleForm() {
      this.discountRule = {
        qty_gt: null,
        discount_value: null
      }
    },

    addBuyGetFreeRuleAction() {
      const ruleAction = Object.assign({}, this.buyGetFreeRule.action);
      const currentRules = this.form.buyXgetYFree.rules;
      currentRules.push(ruleAction)
      this.form.buyXgetYFree.rules = __.orderBy(currentRules, ['qty_gt'], ['asc']);
      this.resetBuyGetRuleForm()
    },

    addDiscountRuleAction() {
      const ruleAction = Object.assign({}, this.discountRule);
      const currentRules = this.form.itemDiscounts.rules;
      currentRules.push(ruleAction)
      this.form.itemDiscounts.rules = __.orderBy(currentRules, ['qty_gt'], ['asc']);
      this.resetDiscountRuleForm()
    },


    removeBuyXGetRule(rule) {
      const currentRules = this.form.buyXgetYFree.rules;
      this.form.buyXgetYFree.rules.splice(currentRules.indexOf(rule), 1);
    },

    removeDiscountRule(rule) {
      const currentRules = this.form.itemDiscounts.rules;
      this.form.itemDiscounts.rules.splice(currentRules.indexOf(rule), 1);
    },

    reloadItemUnits() {
      let selectedOption = this.buyGetFreeRule.action.free_item.item_code;
      if(selectedOption) {
        this.$http.get(this.route('ajax.item_units', {item_code: selectedOption})).then(response => {
          this.buyGetFreeRule.itemCodeUnits = response.data
        })
      }
    },

    searchItemCodes(search, loading) {
      if(search) {
        loading(true)
        this.$http.get(this.route('ajax.items_list_search', {search})).then( response => {
          loading(false)
          this.buyGetFreeRule.selectableItems = response.data;
        })
      }
      return [];
    }
  }
}
</script>
